import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./FlipBubbles.scss"

import dataJSON from "../../api/FlipPic.json"

class FlipBubbles extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    linkDataLayer() {
        push("Read_More_Clicked", "סיפור בלי כיסוי");
    }
    getBubbles() {
        return dataJSON.list.map((item, index) =>
            <PostBubble key={index}
                index={index}
                switchFlip={this.props.switchFlip}
                current={this.props.current} />)
    }
    render() {
        return (
            <div className="bubbles">
                <div className="centeral">
                    {this.getBubbles()}
                </div>
            </div>
        );
    }
}

const PostBubble = (props) => {
    return (
        <div onClick={(index) => { props.switchFlip(props.index) }} className={`bub${(props.index == props.current ? " active" : "")}`}></div>
    )
}

export default FlipBubbles;


// WEBPACK FOOTER //
// ./src/Components/FlipPic/FlipPic.bubbles.js